import { useState } from "react";
import functions from "../../../util/functions";

const VendasPorDiasDaSemana = (props) => {
	if (!props.listVendasPorDia || props.listVendasPorDia.length === 0) {
		return null;
	}

	return (
		<div className="col-12 ">
			<div className="card detail-container">
				<div>
					<h2>Vendas por dia da semana</h2>
					<span>Acumulado do mês</span>
				</div>

				<div className="row">
					{props.listVendasPorDia.map((venda, i) => {
						return (
							<div key={i} className="col-6 col-lg-4 border-right">
								<h6>{venda.diadasemana}</h6>
								<h4>{functions.strToCurrency(venda.totaldia)}</h4>
								<h6>Número de vendas</h6>
								<h4>{venda.qtdevendas}</h4>
								<h6>Ticket Médio</h6>
								<h4>{functions.strToCurrency(venda.ticketmedio)}</h4>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};

export default VendasPorDiasDaSemana;
